import api from "@/services/api";

export const state = {
  associationStatuses: [],
  associationStatus: {},
};

export const mutations = {
  INIT_ASSOCIATION_STATUSES(state, payload) {
    state.associationStatuses = payload;
  },
  INIT_ASSOCIATION_STATUS(state, payload) {
    state.associationStatus = payload;
  },
};

export const actions = {
  getAssociationStatuses({ commit }, payload) {
    return api.getAssociationStatuses(payload).then((response) => {
      commit("INIT_ASSOCIATION_STATUSES", response.data.data);

      if (!payload.retrieveAll) commit("pager/INIT_PAGER", response.data.pagedResult, { root: true });
    });
  },
  getAssociationStatusById({ commit }, payload) {
    return api.getAssociationStatusById(payload).then((response) => {
      commit("INIT_ASSOCIATION_STATUS", response.data.data);
    });
  },
};

export const getters = {
  getAssociationStatuses: (state) => state.associationStatuses,
  getAssociationStatus: (state) => state.associationStatus,
};
